export default __webpack_public_path__ + "static/media/info.55a6e77b.svg";